var _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeHorizontalOverlappingCircles = function SvgThreeHorizontalOverlappingCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 29,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.969,
    cy: 15.157,
    fill: "#CECCCE",
    rx: 5.969,
    ry: 6.013,
    transform: "rotate(180 5.969 15.157)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.366,
    cy: 14.695,
    fill: "#320327",
    rx: 13.875,
    ry: 13.774,
    transform: "rotate(-90 18.366 14.695)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.63,
    cy: 14.696,
    fill: "#FF2E5B",
    rx: 10.175,
    ry: 10.101,
    transform: "rotate(-90 26.63 14.696)"
  })));
};
export { SvgThreeHorizontalOverlappingCircles as ReactComponent };
export default __webpack_public_path__ + "images/three-horizontal-overlapping-circles.svg";